/** Mobile: libs/component-library/src/lib/utils/constants.ts (WINDOW_WIDTH dropped — use CSS / useMediaQuery). */
const APP_HORIZONTAL_PADDING = 20;

/** Minimum hit target for icon-only controls (WCAG 2.5.8 / mobile parity). */
const MIN_TOUCH_TARGET = 40;

export { APP_HORIZONTAL_PADDING, MIN_TOUCH_TARGET };
